import { render, staticRenderFns } from "./news-list.vue?vue&type=template&id=10f44cad&scoped=true&"
import script from "./news-list.vue?vue&type=script&lang=js&"
export * from "./news-list.vue?vue&type=script&lang=js&"
import style0 from "./news-list.vue?vue&type=style&index=0&id=10f44cad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f44cad",
  null
  
)

export default component.exports